module.exports = __webpack_public_path__ + "static/fonts/iconosVidaSoftware.50871ec.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconosVidaSoftware-v1.0/fonts/iconosVidaSoftware.ttf
// module id = jsmt
// module chunks = 3